import React from 'react';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { SENTIMENTS, TRANSLATION_KEY, VERDICT_TYPES } from '../constants';
import { verdictShape } from '../propShapes';
import css from './VerdictBadge.css';

const FAILED_BADGE = 'failed';

const BADGES = {
    [SENTIMENTS.HEADS_UP]: { icon: 'trending-down', className: 'headsUp' },
    [SENTIMENTS.GOOD_NEWS]: { icon: 'trending-up', className: 'goodNews' },
    [SENTIMENTS.NEUTRAL]: { icon: 'minus', className: 'neutral' },
    [SENTIMENTS.PROMPT_UNCLEAR]: { icon: 'point-filled', className: 'needsReply' },
    [FAILED_BADGE]: { icon: 'alert-triangle', className: 'failed' },
    [VERDICT_TYPES.NO_VERDICT]: { icon: 'minus', className: 'noVerdict' },
};

const getBadgeState = verdict => {
    if (!verdict) return null;
    if (verdict.type === VERDICT_TYPES.NO_VERDICT) return VERDICT_TYPES.NO_VERDICT;
    if (verdict.type === VERDICT_TYPES.ERROR) return FAILED_BADGE;
    return BADGES[verdict.sentiment] ? verdict.sentiment : SENTIMENTS.NEUTRAL;
};

const VerdictBadge = ({ verdict = null }) => {
    const state = getBadgeState(verdict);
    if (!state) return null;
    const { icon, className } = BADGES[state];
    return (
        <span className={classNames(css.badge, css[className])}>
            <Icon name={icon} size={IconSizes.XX_SMALL} className={css.badgeIcon} interactive={false} />
            <Translate id={`${TRANSLATION_KEY}.BADGES.${state.toUpperCase()}`} />
        </span>
    );
};

VerdictBadge.propTypes = {
    verdict: verdictShape,
};

export default VerdictBadge;
